const hollowToHemSelect = () => {
  const element = document.getElementById('hollow-to-hem')
  const closehollowToHemSelect = document.getElementById('closeHth')

  const modalHollowToHemSelect = document.getElementsByClassName('hth-x-modal')[0]

  if (element) {
   const __onChangeSelect = () => {
      element.addEventListener("change", function(el) {
        let elementDisclaimerProduct  = document.getElementById( 'wp-checkbox-special-order' )
        let estimatedEl = document.getElementById( 'estimated-delivery' )
        localStorage.setItem('hollow-to-hem-selected', el.target.value)

        // Whether this variant is made to order. Read from the data attribute
        // set by theme.js:renderFulfillment, which is the only writer of that
        // block. This used to sniff the block's innerHTML for the literal
        // string "Special Order", so any copy change silently hid the
        // agreement checkbox on a final-sale gown. The innerHTML test is kept
        // only as a fallback for a cached theme.js that predates the attribute.
        let isSpecialOrder = estimatedEl
          ? estimatedEl.getAttribute('data-fulfillment') === 'special-order' ||
            (!estimatedEl.hasAttribute('data-fulfillment') && String(estimatedEl.innerHTML).includes('Special Order'))
          : false;

        if(el.target.value != `Standard - 59”` ){
          // modalHollowToHemSelect.style.opacity = 1
          // modalHollowToHemSelect.style.visibility = 'visible'
          if (elementDisclaimerProduct?.style) elementDisclaimerProduct.style.display = 'flex';
        } else if (elementDisclaimerProduct?.style && !isSpecialOrder){
          elementDisclaimerProduct.style.display = 'none';
        }
      });
      // closehollowToHemSelect.addEventListener("click", function() {
      //   modalHollowToHemSelect.style.opacity = 0
      //   modalHollowToHemSelect.style.visibility = 'hidden'
      // });
    } 
    __onChangeSelect()
  }
}

const hollowToHemInfo = () => {
  const elementInfo = document.getElementById('hollow-to-hem-info')
  const closehollowToHemInfo = document.getElementById('closeHthInfo')

  
  const modalHollowToHemInfo = document.getElementById('hth-x-modal-info')

  const __onClickInfo = () => {
    elementInfo.addEventListener("click", function(el) {
      modalHollowToHemInfo.style.opacity = 1
      modalHollowToHemInfo.style.visibility = 'visible'
    });
  
    closehollowToHemInfo.addEventListener("click", function() {
      modalHollowToHemInfo.style.opacity = 0
      modalHollowToHemInfo.style.visibility = 'hidden'
    });
  }

  __onClickInfo()
}

Promise.all([
  hollowToHemSelect(),
  // hollowToHemInfo()
]) 


var downIcon ='<svg xmlns="http://www.w3.org/2000/svg" style="padding-top:-5;margin-left: -7px;scale: 0.4;" height="38" width="38"><path d="m24 30.8-12-12 2.15-2.15L24 26.5l9.85-9.85L36 18.8Z"/></svg>'
var customerReviewElement = '<div><span>Customer Review(s)</span></div>'

const handleScrollToReview=()=> {
  let count = 100
  try {
    const scrollInterval = setInterval(scrollToReview, 100);
    function scrollToReview() {
    // const targetScroll = document.querySelector(".jdgm-rev-widg__title");
    // targetScroll?.scrollIntoView();
    var displayFormReview = document.querySelector('form.jdgm-form')
    var spanArrowDown = document.querySelector('#review-show span')
    if (displayFormReview?.style && spanArrowDown?.style) {
      spanArrowDown.style.transform="rotate(-0deg)" 
      displayFormReview.style.display='flex'
      clearInterval(scrollInterval);
    } else {
      if (count <= 0) {
        clearInterval(scrollInterval);
      } else {
        count--
      }
    }  
  }
} catch (error) {
    // console.log('handleScrollToReview error => ', error)
  }

}

document.addEventListener('DOMContentLoaded', (event) => {
  let count = 175
  const myInterval = setInterval(handleWriteToCustomerReview, 75);
  
  var elementClickAble = document.querySelector("div.jdgm-widget");
  elementClickAble?.addEventListener("click", function() {
    handleScrollToReview()
  })
  
  // this is a fuction to set Write to Customer Review on form review
  function handleWriteToCustomerReview() {
   try {
    var headerListReview = document.querySelector('.jdgm-rev-widg__sort-wrapper')
    var listReview= document.querySelector('.jdgm-rev')
      var writeToCustomerReviewElement = `<div id='review-show'><p class='review-show-text'>${!listReview ? 'Be the first to review this product':'Write a Customer Review'}</p><span>${downIcon}</span></div>`
  
     if (headerListReview) {
      if (listReview) {
       document.querySelector('.jdgm-rev-widg__sort-wrapper').style.display='flex'
      } else {
       document.querySelector('.jdgm-rev-widg__sort-wrapper').style.display='none'
      }
    }
    let result = document.querySelector('#review-product-info')
    if (result?.insertAdjacentHTML) {
      result.insertAdjacentHTML('beforeend', writeToCustomerReviewElement)  
      clearInterval(myInterval);
      var elementText = document.querySelector(".review-show-text");
      elementText?.addEventListener("click", function() {
        handleShowFormReview()
      })
      var elementArrow = document.querySelector("#review-show span");
      elementArrow?.addEventListener("click", function() {
        handleShowFormReview()
      })
    }
   } catch (error) {
     // console.log('handleWriteToCustomerReview error => ', error)
   }
  }
  // close

  
  // this is a fuction to set Customer Review on list review
  const myInterval2 = setInterval(handleCustomerReview, 100);
  function handleCustomerReview() {
    try {
      var result = document.querySelector('.jdgm-rev-widg__sort-wrapper')
      if (result?.insertAdjacentHTML) {
        setTimeout(function(){
          result.insertAdjacentHTML('afterbegin', customerReviewElement)
        },  500);
        clearInterval(myInterval2);
      } else {
        if (count <= 0) {
          //clear all interval
          clearInterval(myInterval);
          clearInterval(myInterval2);
        } else {
          count--
        }
      }
    } catch (error) {
      // console.log('handleCustomerReview error => ', error) 
    }
  }
  // close
  
});

// handle show form review
const handleShowFormReview = () => {
  try {
    var displayFormReview = document.querySelector('form.jdgm-form')
    if (displayFormReview?.style?.display == 'flex') {
      document.querySelector("#review-show span").style.transform="rotate(-90deg)"
      document.querySelector('form.jdgm-form').style.display='none'
    } else {
      document.querySelector("#review-show span").style.transform="rotate(-0deg)" 
      document.querySelector('form.jdgm-form').style.display='flex'
    }
  } catch (error) {
    // console.log('handleShowFormReview error => ', error)     
  }
}


// Get the modal for try-at-home-wedding banner
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal 
if(btn) {
  btn.onclick = function() {
    modal.style.display = "block";
  }
}

// When the user clicks on <span> (x), close the modal
if(span) {
  span.onclick = function() {
    modal.style.display = "none";
  }
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}


